import { addStyles } from 'ethcss'
import { IStyles } from 'theme'

export const styles: IStyles = {
    buttonWrapper: {
        marginTop: 20,
        display: 'flex',
        justifyContent: 'center',
    },
}

addStyles(styles)
